<div class="widget-container" #chartContainer>
    <div class="widget" [style.borderColor]="borderColor" [style.width]="'inherit'" [style.height]="'inherit'"
        (mouseenter)="widget.showEdit = true" (mouseleave)="widget.showEdit = false" #chartRef>

        <!-- Widgets selon le type de chart -->
        <app-widget-host [widget]="widget" [inputs]="{
            width: widget.width || 600, height: widget.height || 400, refreshSignal: refreshSignal,
            signalSingled: widget.signalSingled, projects: projects }">
        </app-widget-host>

        <div class="edit-buttons" *ngIf="widget.showEdit">
            <lib-button (click)="exportChart(widget)" color="none" textColor="primary" icon="cloud_download">
            </lib-button>

            <lib-button (click)="refreshChart(widget)" color="none" textColor="primary" icon="refresh">
            </lib-button>

            <lib-button *ngIf="this.user && !(this.user.role.name == 'user' || this.user.role.name == 'guest')"
                (click)="duplicateChart(widget)" color="none" textColor="primary" icon="content_copy"></lib-button>

            <lib-button *ngIf="this.user && !(this.user.role.name == 'user' || this.user.role.name == 'guest')"
                (click)="editWidget(widget)" color="none" textColor="primary" icon="edit"></lib-button>

            <lib-button (click)="closeFullscreen()" color="none" textColor="primary"
                icon="fullscreen_exit"></lib-button>
        </div>
    </div>
</div>